import React from "react";
import PropTypes from "prop-types";
import Header from "../Header";
import MenuList from "../MenuList";
import styles from "./Navbar.module.css";

const Navbar = ({
  onClick,
  isHome,
  menuItems,
  activeTab,
  onTabClick,
  cartCount = 0,
}) => {
  return (
    <>
      <div className={styles.container}>
        <div className={styles.headerContainer}>
          <Header onClick={onClick} isHome={isHome} />
        </div>

        <div className={styles.verticalLine} />

        <div className={styles.menuListContainer}>
          <MenuList
            menuItems={menuItems}
            activeTab={activeTab}
            onTabClick={onTabClick}
            cartCount={cartCount}
          />
        </div>
      </div>

      <div className={styles.dottedLine} />
    </>
  );
};

Navbar.propTypes = {
  onClick: PropTypes.func.isRequired,
  isHome: PropTypes.bool.isRequired,
  menuItems: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      href: PropTypes.string.isRequired,
    })
  ).isRequired,
  activeTab: PropTypes.string.isRequired,
  onTabClick: PropTypes.func.isRequired,
  cartCount: PropTypes.number,
};

export default Navbar;
